// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gspzWAUKnLP7VUkND9b9 {

    height: auto;

    width: 100%
}

.BFIE9gWgX12jiJjMaBEj {

    display: flex;

    width: 100%;

    justify-content: space-between;

    gap: 2.25rem
}

.tGQYc3TkAlQgGqd4_0yw {

    display: flex;

    height: auto;

    width: 100%;

    flex-wrap: wrap;

    row-gap: 2.5rem
}

.BvjBXbaNVmFWedLEy72Q {

    width: 100%
}

.Wj7SCsc_5i2mnUBFIo1R {

    width: 100%
}
.OJcFXHo364MuLLGNPRTM {

    height: 46px !important;

    width: 100% !important
}
.uLBnjHHYmqUp06_smg8l input {

    height: 46px !important;

    padding-top: 6px !important;

    padding-bottom: 6px !important;

    padding-left: 11px !important;

    padding-right: 11px !important;

    line-height: 46px !important
}

.zB_cs453b3dgMQIAEHiZ {

    margin-top: 0.5rem;

    display: flex;

    width: 100%;

    justify-content: flex-end;

    gap: 1rem
}

.TQHKE_fmVvA0CLZvoEgG {

    height: 38px;

    width: 120px;

    --tw-border-opacity: 1;

    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}

.TQHKE_fmVvA0CLZvoEgG:hover {

    --tw-border-opacity: 1 !important;

    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}

.aQV9PCjZXy3KrX6C6b6o {

    height: 38px;

    width: 120px;

    --tw-bg-opacity: 1;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.aQV9PCjZXy3KrX6C6b6o:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.sSUg289PsxpSI24T0imI {

    display: flex
}

.sSUg289PsxpSI24T0imI .ant-checkbox .ant-checkbox-inner {

    border-radius: 2px;

    --tw-border-opacity: 1 !important;

    border-color: rgb(225 225 225 / var(--tw-border-opacity, 1)) !important
}

.sSUg289PsxpSI24T0imI .ant-checkbox-checked .ant-checkbox-inner {

    --tw-border-opacity: 1 !important;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important
}

.sSUg289PsxpSI24T0imI .ant-checkbox-wrapper {

    font-family: Noto Sans !important;

    font-size: 12px;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(195 195 195 / var(--tw-text-opacity, 1))
}

.vFXCf2wsyypi8Em490Rc {

    font-family: Noto Sans;

    font-size: 1.125rem;

    line-height: 1.75rem;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.BvjBXbaNVmFWedLEy72Q .ant-form-item-label > label {

    --tw-text-opacity: 1;

    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.gF63tv2VSFYz0OKx41if {

    --tw-border-opacity: 1 !important;

    border-color: rgb(228 229 231 / var(--tw-border-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/Account/Address/AddressEditForm/AddressEditForm.module.css"],"names":[],"mappings":"AACE;;IAAA,YAAoB;;IAApB;AAAoB;;AAIpB;;IAAA,aAAwC;;IAAxC,WAAwC;;IAAxC,8BAAwC;;IAAxC;AAAwC;;AAIxC;;IAAA,aAA4C;;IAA5C,YAA4C;;IAA5C,WAA4C;;IAA5C,eAA4C;;IAA5C;AAA4C;;AAI5C;;IAAA;AAAa;;AAIb;;IAAA;AAAa;AAGb;;IAAA,uBAAwB;;IAAxB;AAAwB;AAGxB;;IAAA,uBAAqD;;IAArD,2BAAqD;;IAArD,8BAAqD;;IAArD,6BAAqD;;IAArD,8BAAqD;;IAArD;AAAqD;;AAIrD;;IAAA,kBAAyC;;IAAzC,aAAyC;;IAAzC,WAAyC;;IAAzC,yBAAyC;;IAAzC;AAAyC;;AAIzC;;IAAA,YAA0E;;IAA1E,YAA0E;;IAA1E,sBAA0E;;IAA1E,0DAA0E;;IAA1E,kBAA0E;;IAA1E,4DAA0E;;IAA1E,oBAA0E;;IAA1E,qBAA0E;;IAA1E,mBAA0E;;IAA1E,sBAA0E;;IAA1E,oBAA0E;;IAA1E;AAA0E;;AAI1E;;IAAA,iCAAgD;;IAAhD,qEAAgD;;IAAhD,6BAAgD;;IAAhD,uEAAgD;;IAAhD,+BAAgD;;IAAhD;AAAgD;;AAIhD;;IAAA,YAA2D;;IAA3D,YAA2D;;IAA3D,kBAA2D;;IAA3D,0DAA2D;;IAA3D,oBAA2D;;IAA3D,qBAA2D;;IAA3D,mBAA2D;;IAA3D,sBAA2D;;IAA3D,oBAA2D;;IAA3D;AAA2D;;AAI3D;;IAAA,6BAAgC;;IAAhC,qEAAgC;;IAAhC,+BAAgC;;IAAhC;AAAgC;;AAIhC;;IAAA;AAAW;;AAIX;;IAAA,kBAAkD;;IAAlD,iCAAkD;;IAAlD;AAAkD;;AAIlD;;IAAA,iCAAkC;;IAAlC,qEAAkC;;IAAlC,6BAAkC;;IAAlC;AAAkC;;AAIlC;;IAAA,iCAAqF;;IAArF,eAAqF;;IAArF,gBAAqF;;IAArF,oBAAqF;;IAArF;AAAqF;;AAIrF;;IAAA,sBAAmD;;IAAnD,mBAAmD;;IAAnD,oBAAmD;;IAAnD,gBAAmD;;IAAnD,oBAAmD;;IAAnD;AAAmD;;AAInD;;IAAA,oBAAoB;;IAApB;AAAoB;;AAIpB;;IAAA,iCAA2B;;IAA3B;AAA2B","sourcesContent":[".mainContainer {\n  @apply w-full h-auto;\n}\n\n.row {\n  @apply w-full flex justify-between gap-9;\n}\n\n.personalInfoSection {\n  @apply w-full h-auto flex flex-wrap gap-y-10;\n}\n\n.form {\n  @apply w-full;\n}\n\n.formItem {\n  @apply w-full;\n}\n.customDropdown {\n  @apply !h-[46px] !w-full;\n}\n.cascaseInput input {\n  @apply !h-[46px] !leading-[46px] !py-[6px] !px-[11px];\n}\n\n.buttonsWrapper {\n  @apply w-full flex justify-end gap-4 mt-2;\n}\n\n.clearButton {\n  @apply bg-white text-primary border-secondary px-6 py-2 w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-primary !border-secondary;\n}\n\n.applyButton {\n  @apply bg-secondary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.checkboxGroup {\n  @apply flex;\n}\n\n.checkboxGroup :global(.ant-checkbox .ant-checkbox-inner) {\n  @apply !border-disabledCheckboxColor rounded-[2px];\n}\n\n.checkboxGroup :global(.ant-checkbox-checked .ant-checkbox-inner) {\n  @apply !bg-primary !border-primary;\n}\n\n.checkboxGroup :global(.ant-checkbox-wrapper) {\n  @apply !font-inter text-dashboardSub font-dashboardSub !font-inter text-disabledColor;\n}\n\n.dividerText {\n  @apply text-lg font-medium font-inter text-gray-500;\n}\n\n.form :global(.ant-form-item-label > label) {\n  @apply text-gray-600;\n}\n\n.headingText {\n  @apply !border-dividerColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `gspzWAUKnLP7VUkND9b9`,
	"row": `BFIE9gWgX12jiJjMaBEj`,
	"personalInfoSection": `tGQYc3TkAlQgGqd4_0yw`,
	"form": `BvjBXbaNVmFWedLEy72Q`,
	"formItem": `Wj7SCsc_5i2mnUBFIo1R`,
	"customDropdown": `OJcFXHo364MuLLGNPRTM`,
	"cascaseInput": `uLBnjHHYmqUp06_smg8l`,
	"buttonsWrapper": `zB_cs453b3dgMQIAEHiZ`,
	"clearButton": `TQHKE_fmVvA0CLZvoEgG`,
	"applyButton": `aQV9PCjZXy3KrX6C6b6o`,
	"checkboxGroup": `sSUg289PsxpSI24T0imI`,
	"dividerText": `vFXCf2wsyypi8Em490Rc`,
	"headingText": `gF63tv2VSFYz0OKx41if`
};
export default ___CSS_LOADER_EXPORT___;
